import type { OutboxSender } from '../local/taskOutbox';
import { uploadPreparedTaskFile } from './taskAttachments';
import { addTaskComment, addTaskEvent } from './taskComments';

/**
 * How the task outbox (src/local/taskOutbox.ts, B4) reaches the server: the
 * same calls the task page makes online, with the item's saved keys so a
 * resend is answered with what already landed.
 */
export const taskOutboxSender: OutboxSender = {
  postComment: (item, body) =>
    addTaskComment(item.taskId, body, item.ownerUpn, item.authorName, item.notifyUpns ?? [], item.key),
  uploadFile: (item, blob) =>
    uploadPreparedTaskFile(
      { id: item.taskId, storeId: item.storeId },
      { kind: item.fileKind === 'pdf' ? 'pdf' : 'photo', blob, title: item.fileTitle ?? '', sourceName: item.fileName ?? '' },
      item.ownerUpn,
      item.key,
    ),
  addFileEvent: (item, shownName) =>
    addTaskEvent(item.taskId, 'file', `Added ${shownName}`, item.ownerUpn, item.authorName, '', item.eventKey),
};
